import React from 'react';
import dateFormat from "dateformat";
import * as R from 'ramda'
import Tag from '../components/Tag'
import DateCustomInput from '../components/DateCustomInput'
import moment from "moment/moment";
import classNames from 'classnames'





const HistoryItem = ({data, line, tags, index, user, newHistory, newHistoryCount, inputRef, element}) => {

    const historyClass = classNames({
        'comment__element_new': newHistory,
        'comment__element_first-new': newHistoryCount === 1,
        //'comment__element_new': index === 60,
        //'comment__element_first-new': index === 60,
        'comment__element': true,
        'comment__element_history': true,
    });

    const rendetTask = () => {
        var truncate = R.when(
            s => s.length > 60,
            s => s.slice(0, 60) + '…'
        );
        let text = truncate(line.text.replace(/<\/?[^>]+>/g,''));

        return (
            <div className="history__line-wrap">
                <div className="history__element-index">{index}</div>
                <div className='history__number'>{line.indexLine + 1}</div>
                <div className='history__line'>
                    <div className='history__line-text'>
                        {text}
                    </div>
                </div>
            </div>
        )
    }

    const renderTag = () =>{
        let tag = tags[data.keyTag]

        return <Tag tag={tag} />
    }

    const renderLabelTag = () =>{
        let label = data.status === 'addTag' ? "Добавлен тег:" : "Удален тег:"

        return <div className='history__label-tag'> {label} </div>
    }

    const renderLabelChecked = () =>{
        let label = data.status ? "Задача завершена" : "Задача возвращена"

        return <div className='history__label-tag'> {label} </div>
    }

    const renderDate = () => {
        const date = moment(data.date).format('DD.MM.YYYY')

        return <DateCustomInput type='template' value={date} label={data.label} />
    }

    const renderLabelDate = () =>{
        let label = data.status === 'new' ? "Добавлена дата:" : data.status === 'old' ? "Изменена дата на" : "Удалена дата:"

        return <div className='history__label-tag'> {label} </div>
    }

    const renderComment = () => {
        const text = data.text

        return <div className='history__comment-text'> "{ text }"</div>
    }

    const renderLabelComment = () =>{
        let label = 'Добавлен комментарий:'

        return <div className='history__label-tag'> {label} </div>
    }


    const renderLabelLine = () =>{
        let label = 'Описание изменено'

        return <div className='history__label-tag'> {label} </div>
    }

    const renderTopItem = () => {
        return (
            <div>
                {
                    newHistoryCount === 1 && (
                        <div className='comment__new-hint'>Unread</div>
                    )
                }
                <div className="history__top-wrap">
                    <div className="comment__date history__index">{index}</div>
                    <div className="comment__date comment__date_line">{ dateFormat(data.date, "dddd, mmmm dS, yyyy, HH:MM:ss") }</div>
                </div>
            </div>

        )
    }

    switch(data.type) {
        case 'tag' :
            return (
                <div className={historyClass} id={newHistory ? `comment__element_${newHistoryCount}-new` : `com__elemet-${index}`}>
                    {
                        renderTopItem()
                    }
                    {
                        rendetTask()
                    }
                    <div className="comment__block-bottom">
                         { renderLabelTag() }
                         { renderTag() }
                    </div>
                </div>
            )
        case 'checked' :
            return (
                <div className={historyClass} id={newHistory ? `comment__element_${newHistoryCount}-new` : `com__elemet-${index}`}>
                    {
                        renderTopItem()
                    }
                    {
                        rendetTask()
                    }
                    <div className="comment__block-bottom">
                        { renderLabelChecked() }
                    </div>
                </div>
            )
        case 'date' :
            return (
                <div className={historyClass} id={newHistory ? `comment__element_${newHistoryCount}-new` : `com__elemet-${index}`}>
                    {
                        renderTopItem()
                    }
                    {
                        rendetTask()
                    }
                    <div className="comment__block-bottom">
                        { renderLabelDate() }
                        { renderDate() }
                    </div>
                </div>
            )
        case 'comment' :
            return (
                <div className={historyClass} id={newHistory ? `comment__element_${newHistoryCount}-new` : `com__elemet-${index}`}>
                    {
                        renderTopItem()
                    }
                    {
                        rendetTask()
                    }
                    <div className="comment__block-bottom">
                        { renderLabelComment() }
                        { renderComment() }
                    </div>
                </div>
            )
        case 'line' :
            return (
                <div className={historyClass} id={newHistory ? `comment__element_${newHistoryCount}-new` : `com__elemet-${index}`}>
                    {
                        renderTopItem()
                    }
                    {
                        rendetTask()
                    }
                    <div className="comment__block-bottom">
                        { renderLabelLine() }
                    </div>
                </div>
            )
        default:
            return ''
    }


}



export default HistoryItem;


// WEBPACK FOOTER //
// ./src/components/HistoryItem.js